import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionCreateUserEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getLocaleSelectOptions } from 'shared/utils/locale/get-locale-select-options';
interface ActionCreateUserItemProps extends EditActionItemInterface<ActionCreateUserEditInterface> {}
const ActionCreateUserItem = t0 => {
  const $ = _c(15);
  const {
    actions,
    action,
    errors,
    setRules,
    idx,
    onDelete
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.id || $[4] !== action.locale || $[5] !== actions || $[6] !== errors.automationActions || $[7] !== idx || $[8] !== setRules || $[9] !== t) {
    t2 = t3 => {
      const {
        renderActionLabel
      } = t3;
      return <><FormSelect label={renderActionLabel({
          label: t("dashboard.automation_rule.action.new_user_language")
        })} placeholder={t("dashboard.automation_rule.choose_language_of_user")} value={action.locale} data={getLocaleSelectOptions(t)} onChange={data => setRules(prev => ({
          ...prev,
          actions: actions.map((el, i) => {
            if (idx === i) {
              return {
                ...el,
                locale: data
              };
            } else {
              return el;
            }
          })
        }))} error={errors.automationActions[action.id]?.locale?.join("")} /></>;
    };
    $[3] = action.id;
    $[4] = action.locale;
    $[5] = actions;
    $[6] = errors.automationActions;
    $[7] = idx;
    $[8] = setRules;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== action.type || $[12] !== t1 || $[13] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[11] = action.type;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default ActionCreateUserItem;